// Vue imports
import Vue from "vue";
import { h } from 'vue';
import Router from "vue-router";

// Utils
import { authGuard } from "../auth";

// Screens
import Home from "../views/Home.vue";
import Profile from "../views/Profile.vue";
import Tenants from "../views/tenants/Tenants.vue";
import Devices from "../views/Devices.vue";
import Users from "../views/Users.vue";
import Timesheet from "../views/Timesheet.vue";
import VirtualVisitParticipants from "../views/virtual-visits/participants/Participants.vue";
import BedManager from "../views/bed-manager/BedManager.vue";
import Roles from "../views/Roles.vue";
import Virtualnursing from "../views/Virtualnursing.vue";
import EpicFhirConfiguration from "../views/EpicFhirConfiguration.vue"
import TrainingTool from "../views/training-tool/TrainingTool.vue";
import Caching from "../views/Caching.vue";
import ReleaseNotes from "../views/Releasenotes.vue";
import Locations from "../views/location.vue";
import Saml from "../views/Saml.vue";
import AuthConnection from "../views/AuthConnections.vue";
import DeviceMessages from "../views/DevicesMessages.vue";
import DeviceStatusReport from "../views/DeviceStatusReport.vue";
import DeviceLogs from "../views/DeviceLogs.vue";
import Participant from "../views/Participant.vue";
import VideoCalls from "../views/VideoCalls.vue";
import CallQualityReport from "@/views/CallQualityReport.vue";
import DeviceUptimeLogs from "../views/DeviceUptimeLogs.vue";
import PatientTracking from "@/views/Patient-Tracking.vue";
import GatewayDashboard from '../views/gateway/GatewayDashboard.vue';
import RebootReport from "../views/RebootReport.vue";
import { default as SensorJobs } from "../views/device-jobs/Jobs.vue";
import {default as MediaNodeConfiguration} from "../views/media-node-config/MediaNodeConfig.vue";
import Activities from "../views/Activities.vue";
import SmartORManager from "../views/SmartORManager.vue";

// Router
Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/log-out",
      name: "loggedout",
      component: {
          render() {
              return h('div', { style: { fontSize: '18px', margin: '15px', position: 'fixed', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', pointerEvents: 'none' } }, 'You are logged out.');
          }
      }
    },
    {
      path: "/home",
      name: "home",
      component: Home,
      beforeEnter: authGuard
    },
    {
      path: "/",
      name: "home",
      component: Home,
      beforeEnter: authGuard
    },
    {
      path: '/gateway/dashboard',
      name: 'gateway',
      component: GatewayDashboard,
      beforeEnter: authGuard,
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
      beforeEnter: authGuard
    },
    {
      path: "/tenants",
      name: "tenants",
      component: Tenants,
      beforeEnter: authGuard
    },
    {
      path: "/devices",
      name: "devices",
      component: Devices,
      beforeEnter: authGuard
    },
    {
      path: "/devicesjobs",
      name: "jobs",
      component: SensorJobs,
      beforeEnter: authGuard
    },
    {
      path: "/virtual-visit-participants",
      name: "participants",
      component: VirtualVisitParticipants,
      beforeEnter: authGuard,
    },
    {
      path: "/users",
      name: "users",
      component: Users,
      beforeEnter: authGuard
    },
    {
      path: "/timesheet",
      name: "timesheet",
      component: Timesheet,
      beforeEnter: authGuard
    },
    {
      path: "/roles",
      name: "roles",
      component: Roles,
      beforeEnter: authGuard
    },
    {
      path: "/training-tool",
      name: "training-tool",
      component: TrainingTool,
      beforeEnter: authGuard
    },
    {
      path: "/ReleaseNotes",
      name: "ReleaseNotes",
      component: ReleaseNotes,
      beforeEnter: authGuard
    },
    {
      path: "/virtualnursing",
      name: "Virtualnursing",
      component: Virtualnursing,
      beforeEnter: authGuard
    },
    {
      path: "/epicfhirconfig",
      name: "EpicFhirConfiguration",
      component: EpicFhirConfiguration,
      beforeEnter: authGuard
    },
    {
      path: "/caching",
      name: "Caching",
      component: Caching,
      beforeEnter: authGuard
    },
    {
      path: "/saml",
      name: "Saml",
      component: Saml,
      beforeEnter: authGuard
    },
    {
      path: "/authConnections",
      name: "AuthConnection",
      component: AuthConnection,
      beforeEnter: authGuard
    },
    {
      path: "/devicemessages",
      name: "DeviceMessagesSettings",
      component: DeviceMessages,
      beforeEnter: authGuard
    },
    {
      path: "/location",
      name: "Location",
      component: Locations,
      beforeEnter: authGuard
    },
    {
      path: "/devicestatusreports",
      name: "devicestatusreports",
      component: DeviceStatusReport,
      beforeEnter: authGuard
    },
    {
      path: "/videoCalls",
      name: "videoCalls",
      component: VideoCalls,
      beforeEnter: authGuard
    },
    {
      path: "/activities",
      name: "Activities",
      component: Activities,
      beforeEnter: authGuard
    },
    {
      path: "/participant",
      name: "participant",
      component: Participant,
      beforeEnter: authGuard
    },
    {
      path: "/callquality",
      name: "callquality",
      component: CallQualityReport,
      beforeEnter: authGuard
    },
    {
      path: "/devicelogs",
      name: "devicelogs",
      component: DeviceLogs,
      beforeEnter: authGuard
    },
    {
      path: "/deviceuptimelogs",
      name: "deviceuptimelogs",
      component: DeviceUptimeLogs,
      beforeEnter: authGuard
    },
    {
      path: "/patient-tracking",
      name: "Patient Tracking",
      component: PatientTracking,
      beforeEnter: authGuard
    }, {
      path: "/media-node-config",
      name: "Media Node Configuration",
      component: MediaNodeConfiguration,
      beforeEnter: authGuard
    },
    {
      path: "/smart-or-manager",
      name: "Smart OR Management",
      component: SmartORManager,
      beforeEnter: authGuard
    },
    {
      path: "/bed-manager",
      name: "Bed Manager",
      component: BedManager,
      beforeEnter: authGuard
    },
    {
      path: "/reboot-report",
      name: "Reboot Report",
      component: RebootReport,
      beforeEnter: authGuard
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (!to.query.version) {
    const version = from.query && from.query.version || Date.now()
    next({ path: to.path, query: { ...to.query, version }, replace: true })
  } else {
    next()
  }
})


export default router;
